/**
 * Created with IntelliJ IDEA.
 * User: Elaa
 * Date: 4/6/14
 * Time: 2:47 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.utils = window.lpTag.utils || {};

    var lpAgent = require('web-agent-assets-js/lpAgent');

    function WebAgentSessionStorage(inResume) {
        var sessionDataVars = "WebAgentSessionStorageVars";
        var keys = lpAgent.sessionDataManager.getSessionData(sessionDataVars);
        if (!keys) { // if we haven't loaded anything
            keys = [];
        }
        if (!inResume) {
            cleanSessionData();
        }

        /////////////////////////////Private functions////////////////////////////////////////
        function cleanSessionData() {
            for (var i = 0; i < keys.length; i++) {
                lpAgent.sessionDataManager.removeSessionData(keys[i]);
            }
            keys = [];
            lpAgent.sessionDataManager.removeSessionData(sessionDataVars);
        }

        function getIndexOf(array, searchElement) {
            if (Array.prototype.indexOf) {
                return array.indexOf(searchElement);
            } else {
                var index = -1;
                for (var i = 0; i < array.length && index === -1; i++) {
                    if (array[i] === searchElement) {
                        index = i;
                    }
                }
                return index;
            }
        }

        function updateKeysMapping(key) {
            var sessionData = [];
            if (getIndexOf(keys, key) === -1) { // if it's a new key
                keys.push(key);
            }
            for (var i = 0; i < keys.length; i++) {
                sessionData.push(keys[i]);
            }
            return sessionData;
        }

        function removeKeyMapping(key) {
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] === key) {
                    keys.splice(i, 1);
                }
            }
        }
/////////////////////////////End of private functions////////////////////////////////////////

        function appendToSessionData(key, value) {
            lpAgent.sessionDataManager.appendToSessionData(key, value);
        }

        function setSessionData(key, value) {
            var sessionDataArray = updateKeysMapping(key);
            lpAgent.sessionDataManager.setSessionData(sessionDataVars, sessionDataArray);
            lpAgent.sessionDataManager.setSessionData(key, value);
        }

        function removeSessionData(key) {
            removeKeyMapping(key);
            lpAgent.sessionDataManager.removeSessionData(key);
        }

        function removePartialSessionData(key, value) {
            lpAgent.sessionDataManager.removePartialSessionData(key, value);
        }

        function getSessionData(key) {
            return lpAgent.sessionDataManager.getSessionData(key);
        }

        return {
            appendToSessionData: function (contextName, key, value) {
                appendToSessionData(contextName + '_' + key, value);
            },
            setSessionData: function (contextName, key, value) {
                setSessionData(contextName + '_' + key, value);
            },
            getSessionData: function (contextName, key) {
                return getSessionData(contextName + '_' + key);
            },
            removePartialSessionData: function (contextName, key, value) {
                removePartialSessionData(contextName + '_' + key, value);
            },
            removeSessionData: function (contextName, key) {
                removeSessionData(contextName + '_' + key);
            }
        };
    }

    return WebAgentSessionStorage;

});
